import { isNaN } from "formik";

const PlayerFormat = () => {
	const TeamUniform = "TM";
	const NotSpecifiedUniform = "NA";

	const getUniformNormalized = (uniform) => {
		if (!uniform) {
			return NotSpecifiedUniform;
		}
		if ([TeamUniform, NotSpecifiedUniform].some((u) => u === uniform)) {
			return uniform;
		}
		if (uniform.indexOf("0") !== 0 && uniform.length === 1) {
			return `0${uniform}`.toUpperCase();
		}
		return `${uniform}`.slice(-3).toUpperCase();
	};

	const compareUniforms = (a = "", b = "") => {
		let result;
		if (a === TeamUniform) {
			result = -1;
		} else if (b === TeamUniform) {
			result = 1;
		} else {
			result = a - b;
		}

		if (isNaN(result)) {
			result = a.toString().localeCompare(b.toString());
		}

		return result;
	};

	const resolveTennisPlayerName = (player, firstInitial = false) => {
		return player.uniform === NotSpecifiedUniform
			? "No Player"
			: `${firstInitial ? `${player.firstName.charAt(0)}. ` : player.firstName} ${
					player.lastName
			  }`;
	};

	const getFullName = ({ firstName, lastName, uniform }) => {
		let fullname = `${firstName} ${lastName}`;
		if (uniform) {
			fullname += ` (${uniform})`;
		}

		return fullname;
	};

	return {
		getUniformNormalized,
		compareUniforms,
		resolveTennisPlayerName,
		getFullName,
		TeamUniform,
		NotSpecifiedUniform
	};
};

export default PlayerFormat();
